import client from "./client";

const endpoint = "package-deals/public";

const getPackageDeals = (currency) => {
  const params = currency ? { currency: currency.currency || currency } : {};
  return client.get(endpoint, Object.keys(params).length ? { params } : {});
};

const getPackageDealById = (id, currency) => {
  const params = currency ? { currency: currency.currency || currency } : {};
  return client.get(`${endpoint}/${id}`, { params });
};

export { getPackageDeals, getPackageDealById };
